<script setup lang="ts">
interface DeliciousProps {
  name: string
}

withDefaults(defineProps<DeliciousProps>(), {
  name: 'works'
})

const isMounted = ref(false)
const { isDesktop } = useDevice()

onMounted(() => {
  isMounted.value = true
})
</script>

<template>
  <div
    v-if="isDesktop"
    class="pointer-events-none transition-opacity duration-700 ease-out"
    :class="isMounted ? 'opacity-100' : 'opacity-0'"
  >
    <svg v-if="name === 'works'" width="881" height="376" viewBox="0 0 881 376" fill="none">
      <g filter="url(#filter0_bf_1743_3360)">
        <path
          d="M501.377 194.159C219.217 419.932 145.071 -103.068 31.4354 44.7766C-82.23 192.66 556.537 471.387 772.555 308.593C988.574 145.798 783.537 -31.6134 501.377 194.159Z"
          fill="none"
        />
        <path
          d="M501.377 194.159C219.217 419.932 145.071 -103.068 31.4354 44.7766C-82.23 192.66 556.537 471.387 772.555 308.593C988.574 145.798 783.537 -31.6134 501.377 194.159Z"
          stroke="url(#paint0_linear_1743_3360)"
          stroke-width="3"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1743_3360"
          x="0.500488"
          y="0.5"
          width="879.648"
          height="375.056"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1743_3360" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1743_3360"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1743_3360" />
        </filter>
        <linearGradient
          id="paint0_linear_1743_3360"
          x1="471.747"
          y1="-34.1677"
          x2="936.364"
          y2="180.855"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-if="name === 'clients-top'"
      width="881"
      height="376"
      viewBox="0 0 881 376"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1429_3132)">
        <path
          d="M501.377 194.159C219.217 419.932 145.071 -103.068 31.4354 44.7766C-82.23 192.66 556.537 471.387 772.555 308.593C988.574 145.798 783.537 -31.6134 501.377 194.159Z"
          fill="none"
        />
        <path
          d="M501.377 194.159C219.217 419.932 145.071 -103.068 31.4354 44.7766C-82.23 192.66 556.537 471.387 772.555 308.593C988.574 145.798 783.537 -31.6134 501.377 194.159Z"
          stroke="url(#paint0_linear_1429_3132)"
          stroke-width="3"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1429_3132"
          x="0.5"
          y="0.5"
          width="879.648"
          height="375.056"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1429_3132" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1429_3132"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1429_3132" />
        </filter>
        <linearGradient
          id="paint0_linear_1429_3132"
          x1="471.747"
          y1="-34.1677"
          x2="936.364"
          y2="180.855"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-if="name === 'clients-bot'"
      width="846"
      height="434"
      viewBox="0 0 846 434"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1791_3560)">
        <path
          d="M307.567 121.862C25.4074 347.635 145.203 188.018 31.5681 335.862C-82.0974 483.745 549.549 410.655 765.567 247.861C981.586 85.0672 589.727 -103.911 307.567 121.862Z"
          fill="white"
          fill-opacity="0.7"
        />
        <path
          d="M307.567 121.862C25.4074 347.635 145.203 188.018 31.5681 335.862C-82.0974 483.745 549.549 410.655 765.567 247.861C981.586 85.0672 589.727 -103.911 307.567 121.862Z"
          stroke="url(#paint0_linear_1791_3560)"
          stroke-width="3"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1791_3560"
          x="0.496094"
          y="0.5"
          width="844.985"
          height="432.932"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1791_3560" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1791_3560"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1791_3560" />
        </filter>
        <linearGradient
          id="paint0_linear_1791_3560"
          x1="453.122"
          y1="-43.0463"
          x2="926.069"
          y2="136.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>

    <svg
      v-else-if="name === 'numbers-top'"
      width="993"
      height="476"
      viewBox="0 0 993 476"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1791_3561)">
        <path
          d="M552.695 371.052C270.535 145.28 144.517 322.425 30.8823 174.581C-82.7829 26.6971 585.519 -67.9475 865.106 132.053C1144.69 332.053 834.854 596.825 552.695 371.052Z"
          fill="black"
          fill-opacity="0.1"
        />
        <path
          d="M552.695 371.052C270.535 145.28 144.517 322.425 30.8823 174.581C-82.7829 26.6971 585.519 -67.9475 865.106 132.053C1144.69 332.053 834.854 596.825 552.695 371.052Z"
          stroke="url(#paint0_linear_1791_3561)"
          stroke-width="3"
          style="mix-blend-mode: hard-light"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1791_3561"
          x="0.5"
          y="0.5"
          width="991.881"
          height="474.582"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1791_3561" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1791_3561"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1791_3561" />
        </filter>
        <linearGradient
          id="paint0_linear_1791_3561"
          x1="698.251"
          y1="535.96"
          x2="1171.2"
          y2="356.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'numbers-bot'"
      width="1044"
      height="431"
      viewBox="0 0 1044 431"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1791_3562)">
        <path
          d="M603.649 104.528C321.49 330.301 143.696 -32.3159 30.061 115.528C-83.6043 263.412 636.473 543.528 916.061 343.528C1195.65 143.528 885.808 -121.245 603.649 104.528Z"
          fill="none"
          fill-opacity="0.1"
        />
        <path
          d="M603.649 104.528C321.49 330.301 143.696 -32.3159 30.061 115.528C-83.6043 263.412 636.473 543.528 916.061 343.528C1195.65 143.528 885.808 -121.245 603.649 104.528Z"
          stroke="url(#paint0_linear_1791_3562)"
          stroke-width="3"
          style="mix-blend-mode: hard-light"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1791_3562"
          x="0.5"
          y="0.499023"
          width="1042.84"
          height="430.083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1791_3562" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1791_3562"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1791_3562" />
        </filter>
        <linearGradient
          id="paint0_linear_1791_3562"
          x1="749.205"
          y1="-60.3796"
          x2="1222.15"
          y2="118.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'numbers-clients-top'"
      width="897"
      height="780"
      viewBox="0 0 897 780"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1791_3563)">
        <path
          d="M346.476 577.103C366.751 216.303 -31.7644 281.777 22.7684 103.46C77.3158 -74.9048 879.942 30.8805 879.17 374.637C878.398 718.394 326.2 937.902 346.476 577.103Z"
          fill="none"
          fill-opacity="0.1"
        />
        <path
          d="M346.476 577.103C366.751 216.303 -31.7644 281.777 22.7684 103.46C77.3158 -74.9048 879.942 30.8805 879.17 374.637C878.398 718.394 326.2 937.902 346.476 577.103Z"
          stroke="url(#paint0_linear_1791_3563)"
          stroke-width="3"
          style="mix-blend-mode: hard-light"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1791_3563"
          x="0.136719"
          y="0.50293"
          width="896.534"
          height="779.426"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1791_3563" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1791_3563"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1791_3563" />
        </filter>
        <linearGradient
          id="paint0_linear_1791_3563"
          x1="688.395"
          y1="714.569"
          x2="462.395"
          y2="732.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'numbers-clients-bot'"
      width="897"
      height="780"
      viewBox="0 0 897 780"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1791_3564)">
        <path
          d="M346.476 577.103C366.751 216.303 -31.7644 281.777 22.7684 103.459C77.3158 -74.9051 879.942 30.8803 879.17 374.637C878.398 718.394 326.2 937.902 346.476 577.103Z"
          fill="none"
          fill-opacity="0.1"
        />
        <path
          d="M346.476 577.103C366.751 216.303 -31.7644 281.777 22.7684 103.459C77.3158 -74.9051 879.942 30.8803 879.17 374.637C878.398 718.394 326.2 937.902 346.476 577.103Z"
          stroke="url(#paint0_linear_1791_3564)"
          stroke-width="3"
          style="mix-blend-mode: hard-light"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1791_3564"
          x="0.136719"
          y="0.50293"
          width="896.534"
          height="779.425"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1791_3564" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1791_3564"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_1791_3564" />
        </filter>
        <linearGradient
          id="paint0_linear_1791_3564"
          x1="455.17"
          y1="732.637"
          x2="534.796"
          y2="279.138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'services-medium'"
      width="883"
      height="766"
      viewBox="0 0 883 766"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_1817_3457)">
        <path
          d="M339.476 570.102C359.751 209.303 -38.7644 274.776 15.7684 96.4592C70.3158 -81.9053 872.942 23.88 872.17 367.637C871.398 711.393 319.2 930.902 339.476 570.102Z"
          fill="none"
          fill-opacity="0.1"
        />
        <path
          d="M339.476 570.102C359.751 209.303 -38.7644 274.776 15.7684 96.4592C70.3158 -81.9053 872.942 23.88 872.17 367.637C871.398 711.393 319.2 930.902 339.476 570.102Z"
          stroke="url(#paint0_linear_1817_3457)"
          stroke-width="3"
          style="mix-blend-mode: hard-light"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_1817_3457"
          x="0.136719"
          y="0.50293"
          width="882.534"
          height="765.425"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1817_3457" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1817_3457"
            result="shape"
          />
          <feGaussianBlur stdDeviation="4.5" result="effect2_foregroundBlur_1817_3457" />
        </filter>
        <linearGradient
          id="paint0_linear_1817_3457"
          x1="681.395"
          y1="707.568"
          x2="455.395"
          y2="725.568"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      v-else-if="name === 'statement'"
      width="1116"
      height="411"
      viewBox="0 0 1116 411"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bf_397_2111)">
        <path
          d="M577.397 121.862C295.237 347.635 141.465 152.122 27.8297 299.966C-85.8357 447.849 819.378 410.655 1035.4 247.861C1251.42 85.0672 859.557 -103.911 577.397 121.862Z"
          fill="none"
          fill-opacity="0.2"
        />
        <path
          d="M577.397 121.862C295.237 347.635 141.465 152.122 27.8297 299.966C-85.8357 447.849 819.378 410.655 1035.4 247.861C1251.42 85.0672 859.557 -103.911 577.397 121.862Z"
          stroke="url(#paint0_linear_397_2111)"
          stroke-width="3"
        />
      </g>
      <defs>
        <filter
          id="filter0_bf_397_2111"
          x="0.5"
          y="0.5"
          width="1114.81"
          height="409.803"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_397_2111" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_397_2111"
            result="shape"
          />
          <feGaussianBlur stdDeviation="8" result="effect2_foregroundBlur_397_2111" />
        </filter>
        <linearGradient
          id="paint0_linear_397_2111"
          x1="598.075"
          y1="-39.4981"
          x2="1157.94"
          y2="261.033"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF69E7" />
          <stop offset="0.345" stop-color="#A168FF" stop-opacity="0.55" />
          <stop offset="0.65" stop-color="#68E4FF" stop-opacity="0.3" />
          <stop offset="1" stop-color="#7DFF68" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>
